import React from 'react'
import FlagToggle from '../../../../../sections/submissions/header-section/flag/FlagToggle'
import Editor from '../../../../../../../components/common/Editor/Editor'
import { Flex } from 'antd'
import Text from 'antd/es/typography/Text'
import { useAnswerContext } from './AnswerContext'
import { getAnswerByQuestion } from '../../../../../../../utils/question.helper'
import { getColorByIndex } from '../../../../../../../utils/colors.helper'
import { getCategoryById } from '../../../../../../../store/apis/utils/selectors/question.api.selectors'
import { warningBackgroundColor, warningTextColor } from '../../../../../../../constants/styles'
import { useExplanation } from '../../../../../../../store/apis/utils/hooks/category.hooks'
import { ExplainabilityStatuses } from '../../../../../../../constants/explainability-statuses'
import { useSelector } from 'react-redux'
import textSubmissionDrawerSelectors from '../../../../../../../store/selectors/text-submission-drawer.selectors'
import AttachmentsDropdown from './components/AttachmentsDropdown'

const useHighlights = ({ question, answers }) => {
    const focusedQuestionId = useSelector(textSubmissionDrawerSelectors.focusedQuestionId)

    const answer = getAnswerByQuestion(answers, question, focusedQuestionId)
    const { categoryIdToHighlight } = useAnswerContext()
    const categoryToHighlight = categoryIdToHighlight ? getCategoryById([question], categoryIdToHighlight) : null

    const currentCategoryId = answer?.categoryId

    const { explanation, isFetching } = useExplanation(answer)

    const mapHighlightRanges = (ranges, isAdequate) =>
        ranges?.map(({ start, end, importance }) => ({
            start,
            end,
            opacity: importance / 2,
            color: isAdequate ? getColorByIndex(categoryToHighlight?.colorId).value : warningBackgroundColor,
            textColor: isAdequate ? null : warningTextColor,
        })) || []

    const highlightRanges = (() => {
        if (categoryIdToHighlight === currentCategoryId)
            return mapHighlightRanges(answer?.highlights, answer?.isAdequate)
        if (answer) return mapHighlightRanges(explanation?.highlights, explanation?.isAdequate)
        return []
    })()

    return { highlightRanges, isFetching }
}

const AnswerEditor = ({ submissionId, answers, question }) => {
    const { highlightRanges, isFetching: isFetchingHighlights } = useHighlights({ question, answers })

    const editorTitle = (
        <Flex justify='space-between' className='f-width'>
            <Text>Answer</Text>
            {isFetchingHighlights && <Text type='secondary'>Fetching highlights...</Text>}
        </Flex>
    )

    const answer = getAnswerByQuestion(answers, question)

    return (
        <Editor
            title={editorTitle}
            value={answer.content}
            wrapperStyles={{ height: '100%' }}
            readOnly
            showLineNumbers={false}
            wrapLines
            wordsLimit={question.wordsLimit}
            showWordsCount
            extraActions={[
                <FlagToggle
                    key='flag'
                    answerId={answer.id}
                    submissionId={submissionId}
                    questionId={question.id}
                    flagged={answer.escalated === ExplainabilityStatuses.MANUAL_UNRESOLVED}
                />,
            ]}
            highlightRanges={highlightRanges}
            footer={<AttachmentsDropdown
                submissionId={submissionId}
                questionId={question.id}
            />}
        />
    )
}

export default AnswerEditor
